import React, {Component} from 'react';
import TimeGrid from './TimeGrid';
import moment from 'moment';
import AppCalendarCell from './Appointments/AppCalendarCell';
import User from '../api/User';
import Icon from '../components/Icon';
import Appointment, {ParseConflicts} from '../api/Appointment';
import AppointmentService from '../api/services/AppointmentService';
import ClinicService from '../api/services/ClinicService';
import CalendarAppointment from "./Appointments/CalendarAppointment";
import {NotificationManager} from "react-notifications";
import {ExtAppToIntApp} from "../api/services/ExtAppService";
import BCCalendarAppointmentCell from "../components/biopedConnect/BCCalendarAppointmentCell";


const appServ = new AppointmentService();

export default class CalendarDayView extends TimeGrid {
	gridActiveMatrix = [];

	constructor(props) {
		super(props);
		this.getDateFromPos = this.getDateFromPos.bind(this);
		this.getPosFromDate = this.getPosFromDate.bind(this);
		this.handleUpdateApp = this.handleUpdateApp.bind(this);


	}

	getColumnHeaders() {
		this.gridActiveMatrix = [];
		let colItems = this.props.colItems;
		let days = [];
		console.log('Day View Cols Items:', colItems)

		for (let i = 0; i < colItems.length; i++) {
			let user = new User(colItems[i]);
			this.gridActiveMatrix.push(this.calcMatrix(user.userId));

			days.push(<div key={i} className='day-view-column-header'>{user.fullName} <span className='close-btn'
			                                                                                onClick={() => this.removeColumn(i)}><Icon
				icon='x'/></span></div>);

		}

		console.log('Day View Column Heades:', days)

		return days;
	}

	calcMatrix(doctorId) {
		const doctor = ClinicService.GetDrById(doctorId);
		const schedule = doctor.settings.schedule.cache;
		let date = this.props.date;
		let nDate = moment(date).clone();
		let hours = schedule.getDateHours(nDate);
		let o = [];
		if (hours) {
			let startTime = moment(hours[0], 'h:mm a');
			let endTime = moment(hours[1], 'h:mm a');
			let rowStart = this.getRowFromTime(startTime);
			let rowEnd = this.getRowFromTime(endTime);

			return [rowStart, rowEnd];

			/*for (let i = rowStart; i < rowEnd; i++) {
				o.push(i);
			}*/
		}

		return o;

	}

	generateActiveCellStyle() {
		let activeMatrix = this.gridActiveMatrix;
		let segsPerRow = this.colSegs;
		let style = [];
		for (let day = 0; day < activeMatrix.length; day++) {
			let segments = activeMatrix[day];
			for (let i = 0; i < segments.length; i++) {
				let segment = segments[i];
				let row = parseInt(segment / segsPerRow, 10);
				let subSeg = 1 + (segment % segsPerRow);
				let s = `.grid-view [col="` + day + `"][row="` + row + `"] > div >:nth-child(` + subSeg + `){
                            background-color: #fff;
                            cursor: cell;
                            pointer-events: all;
                        }`;
				style.push(s);
			}
		}

		//console.log('@@@@@@ ActiveSell Style: ', style);
		return style;
	}


	removeColumn(col) {
		console.log("Column:", col)
		let items = this.props.colItems;
		items.splice(col, 1);
		if (this.props.onColChange) {
			this.props.onColChange(items)
		}
	}

	getDateFromPos(col, row) {
		let date = moment(this.props.date);
		let time = this.getTimeFromRow(row);
		//date.day(col);
		date.hour(time.hour());
		date.minutes(time.minute());
		date.second(0);
		return date;
	}

	getPosFromDate(date) {
		date = moment(date);
		let col = date.day() * this.colSegs;
		let row = this.getRowFromTime(date);
		return [row, col];
	}

	getItemCol(item) {
		if (item) {
			let colItems = this.props.colItems;
			for (let i = 0; i < colItems.length; i++) {
				let colData = colItems[i] || {};
				if (item.userId == colData.userId) {
					return i * this.colSegs;
				}
			}
		}

		return null;
	}

	/*getHeader(){
		console.log("Get Header");
		return <div>{moment(this.props.date).format('ddd D')}</div>
	}*/

	extractStackedApps() {
		let apps = this.getAppointments();
		let stacks = {};
		let o = [];

		for (let i = 0; i < apps.length; i++) {
			let app = apps[i];
			let id = Appointment.FormatAppId(app);
			if (stacks[id] == null) {
				stacks[id] = [];
			}
			stacks[id].push(app);
		}

		for (let p in stacks) {
			o.push(stacks[p])
		}

		return o;

	}

	getAppointments() {
		return this.props.appointments.filter(app => moment(app.start).format('YYYY/M/D') == moment(this.props.date).format('YYYY/M/D'));
	}

	getItems() {
		//console.log('getItems Date:', moment(this.props.date).format('YYYY/M/D'));
		let apps = Appointment.FindConflicts(this.getAppointments());// this.extractStackedApps(); //this.props.appointments.filter( app => moment(app.start).format('YYYY/M/D') == moment(this.props.date).format('YYYY/M/D'));
		let items = {};
		for (let i = 0; i < apps.length; i++) {
			let app = apps[i];

			let itemOffset = ParseConflicts(app);
			//console.log("ParseConflicts:", itemOffset);


			let xOffset = itemOffset[app.appointmentId] || 0;
			let count = Object.keys(itemOffset).length || 1;


			let rowStart = this.getRowFromTime(app.start);
			let rowEnd = this.getRowFromTime(app.end);

			let bounds = {};// this.newGridData();

			let w = this.colSegs / count;


			bounds.w = w;

			bounds.x = this.getItemCol(app);


			if (bounds.x === null) continue;

			bounds.x += (xOffset * w);


			bounds.y = rowStart;
			bounds.h = rowEnd - rowStart;

			items[app.appointmentId] = {
				item: <CalendarAppointment id={app.appointmentId} appointment={app} grid={this} onSelect={this.props.onAppointmentSelect}/>,
				bounds: [bounds.x, bounds.y, bounds.w, bounds.h],
				appointment: app,
				allowResize: true,
				draggable: true
			}

			/*items.push({
				item: <CalendarAppointment id={gridData.i} appointment={app} grid={this} onUpdateApp={this.handleUpdateApp} onSelect={this.props.onAppointmentSelect}/>
			})

			items.push(
				<div key={gridData.i} data-grid={gridData}>
					<AppCalendarCell id={gridData.i} appointment={app} grid={this} onUpdateApp={this.handleUpdateApp} onSelect={this.props.onAppointmentSelect}/>
				</div>
			)*/
		}

		return items;
	}

	__handleGridItemDragStart = (item, bounds, itemId, eventName, touchEvent) => {
		console.log('~~~~ Item Drag Start ~~~~');

	}
	__handleGridItemDrop = (item, bounds, itemId, eventName, touchEvent) => {
		console.log('~~~~ Item Drop ~~~~', item, 'Bounds:', bounds);
		if(item)this.handleUpdateApp(item.appointment, bounds);
	}

	handleUpdateApp(app, bounds, isUndo = false) {
		if (this.state.isBusy) return;
		const undo = {
			app: app,
			start: app.start,
			end: app.end
		};
		if(!isUndo) {
			const pos = {
				x: bounds[0],
				y: bounds[1],
				w: bounds[2],
				h: bounds[3]
			}

			//const app = item.appointment;

			//console.log("Handle Update:", pos)


			let start = this.getDateFromPos(pos.x, pos.y);// this.getTimeFromRow(pos.y);
			let end = this.getDateFromPos(pos.x, pos.y + pos.h);
			let doctor = this.props.colItems[parseInt(pos.x / this.colSegs, 10)];

			//if(!doctor)return;

			console.log("Change To Doctor:", doctor);

			app.start = start.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);
			app.end = end.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);
			app.userId = doctor.userId;

			console.log("start:", app.start, "  end:", app.end)

			console.log('appServe:', appServ);
		}

		//let appServ = new AppointmentService();


		this.setState({isBusy: true});

		return appServ.createApp(app).then((d) => {
			console.log("Appointment Updated:", d);
			if(!isUndo){
				NotificationManager.success(
					<div>
                            <span className='app-undo-btn' onClick={()=>{
	                            const undoApp = undo.app;
	                            undoApp.start = undo.start;
	                            undoApp.end = undo.end;
	                            this.handleUpdateApp(undoApp, bounds, true)
                            }}>UNDO
                            </span>
						<div className='notification-close-btn'>x</div>
					</div>

					, 'Appointment Updated!', 5000
				);
			} else {
				if(this.props.refresh){
					console.log('Refreshing Apps')
					this.props.refresh();
				}
			}
			this.setState({isBusy: false})
		})
	}

	onEmptyCellClick = (row, col) => {
		if (this.props.onCreateAppointment) {
			console.log('Col:', col, '  colItems:', this.props.colItems)
			let date = this.getDateFromPos(col, row);

			this.props.onCreateAppointment({
				start: date.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS),
				end: date.add(30, 'minutes').format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS),
				userId: this.props.colItems[parseInt(col / this.colSegs, 10)].userId
			})
		}
	}

	getClassNames() {
		return 'calendar-day-view';
	}

	hiddenStuff() {
		console.log("*** Grid Active Matrix:", this.gridActiveMatrix);
		let style = this.generateActiveCellStyle().join("\n");

		return <style dangerouslySetInnerHTML={{__html: style}}/>
	}

	getScheduleItems(){

		let activeMatrix = this.gridActiveMatrix;
		let segsPerRow = this.colSegs;
		let items = {};

		console.log('Active Matrix:', activeMatrix);

		for(let day = 0; day < activeMatrix.length; day++){
			let segments = activeMatrix[day];

			if(segments.length < 2)continue;

			const dayStart = segments[0];
			const dayEnd = segments[1] - dayStart;



			items[`active-cell-${day}`] = {
				item:'',
				bounds:[day * segsPerRow, dayStart, segsPerRow, dayEnd],
				className: 'active-cell',
				static: false,
				draggable: false
			}


			/*for(let i=0; i < segments.length; i++){
				let segment = segments[i];
				let row = parseInt(segment / segsPerRow, 10);
				let subSeg = 1 + (segment % segsPerRow);
				let s = `.grid-view [col="` + day +`"][row="` + row +`"] > div >:nth-child(` + subSeg + `){
							background-color: #fff;
							cursor: cell;
							pointer-events: all;
						}`;

			}*/
		}
		console.log('*%* Scheduled ITems:',items );
		return items;
	}

	getBCItems() {
		return this.bcAppsToItems(this.props.bcApps);
	}

	bcAppsToItems(bcapps) {
		// console.log("Conflict Apps:", apps);

		//let weekRange = moment(this.props.date);
		const weekStart = moment(this.props.date).day(0);
		const weekEnd = moment(this.props.date).day(6);


		const apps = (bcapps || []).filter( app => {
			return moment(app.startDate).format('YYYY/M/D') === moment(this.props.date).format('YYYY/M/D');
		});

		let items = [];

		for(let i=0; i < apps.length; i++){
			let app = ExtAppToIntApp(apps[i]);

			/*  let itemOffset = ParseConflicts(app);
			  //console.log("ParseConflicts:", itemOffset);


			  let xOffset = itemOffset[app.appointmentId] || 0;
			  let count = Object.keys(itemOffset).length || 1;*/

			let xOffset = 0;

			let rowStart = this.getRowFromTime(app.start);
			let rowEnd = this.getRowFromTime(app.end);

			let bounds = {};// this.newGridData();

			let w = this.colSegs;


			bounds.w = w;

			bounds.x = this.getItemCol(app);


			if (bounds.x === null) continue;

			bounds.x += (xOffset * w);


			bounds.y = rowStart;
			bounds.h = rowEnd - rowStart;


			items[app.externalAppointmentId] = {
				item: <BCCalendarAppointmentCell id={app.externalAppointmentId} appointment={app} grid={this} onSelect={this.props.onAppointmentSelect}/>,
				bounds: [bounds.x, bounds.y, bounds.w, bounds.h],
				appointment: app,
				allowResize: false,
				draggable: false
			}
		}
		return items;
	}
}



// WEBPACK FOOTER //
// ./src/views/CalendarDayView.js